export default {
  'quotation.form.reportType': 'Selecione o Tipo de Relatório',
  'quotation.form.reportType.itemsSuppliers': 'Itens/Fornecedores',
  'quotation.form.reportType.suppliersItems': 'Fornecedores/Itens',
  'quotation.form.reportType.lowestPrice': 'Menor Preço',
  'quotation.form.reportType.vehicleQuotation': 'Veículo/Cotação',
  'quotation.form.reportType.OSQuotation': 'OS/Cotação',

  'quotation.form.orderBy': 'Ordenar por',
  'quotation.form.orderBy.items': 'Itens',
  'quotation.form.orderBy.suppliers': 'Fornecedores',

  'quotation.moreOptions': 'Mais Opções',
  'quotation.moreOptions.button.selectSupplier': 'Selecionar Fornecedores',
  'quotation.moreOptions.button.selectVehicle': 'Selecionar veículo',
};
